jQuery($ => {
    class MenuLinks {
      constructor(element) {
        this._           = element;
        this._element    = $(element);
        this._list       = this._element.find('.m-menu__list');
        this._item       = this._element.find('.m-menu__item');
        this._link       = this._element.find('.m-menu__link');
        this._dropButton = this._element.find('.m-menu__link--dropdown');
        this._dropDown   = this._element.find('.m-menu__dropdown');

        this._focusable = 'button, [href]';
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        this._dropButton.on('mousedown', this.handleDropButtonMousedown);
        this._dropButton.on('keydown', this.handleDropButtonKeydown);
        this._link.on('keydown', this.handleLinkKeydown);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle DropButton Mousedown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleDropButtonMousedown = event => {
        event.stopPropagation();

        const id        = $(event.currentTarget).attr('aria-controls');
        const $dropdown = $(`#${id}`);

        if (!$dropdown[0]) return;

        this.handleDropdownToggle($dropdown);
      }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle DropButton Keydown
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleDropButtonKeydown = event => {
      const id        = $(event.currentTarget).attr('aria-controls');
      const $dropdown = $(`#${id}`);

      if (!$dropdown[0]) return;

      switch (event.key) {
        case 'Enter':
        case 'spacebar':
        case ' ':
        case 'ArrowRight':
          event.preventDefault();
          this.handleDropdownToggle($dropdown);
          break;

        case 'Tab':
          const $focusable      = $dropdown.find(this._focusable);
          const $firstFocusable = $focusable[0];
          const $lastFocusable  = $focusable[$focusable.length - 1];
  
          if (
            ($(event.target).is($lastFocusable) && !event.shiftKey) ||
            ($(event.target).is($firstFocusable) && event.shiftKey)
          ) {
            event.preventDefault();
  
            if ($(event.target).is($lastFocusable)) {
              $firstFocusable.focus();
            } else {
              $lastFocusable.focus();
            }
          }
          break;
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Link Keydown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleLinkKeydown = event => {
        const $link      = $(event.currentTarget);
        const $item      = $link.closest('.m-menu__item');
        const $list      = $link.closest('.m-menu__list');
        const $dropdown  = $link.closest('.m-menu__dropdown');
        
        switch (event.key) {
          case 'ArrowUp':
            event.preventDefault();
            
            const $prevItem = $item.prev();

            if ($prevItem[0]) {
              $prevItem.find(".m-menu__link").focus();
            } else {
              $list.find('.m-menu__item').last().find(".m-menu__link").focus();
            }
            break;

          case 'ArrowDown':
            event.preventDefault();
            const $nextItem = $item.next();

            if ($nextItem[0]) {
              $nextItem.find(".m-menu__link").focus();
            } else {
              $list.find('.m-menu__item').first().find(".m-menu__link").focus();
            }
            break;

          case 'ArrowLeft':
            event.preventDefault();
            
            if ($dropdown[0]) {
              this.handleDropdownClose($dropdown);
              $dropdown.slideUp();
            }
            break;

          case 'Home':
            event.preventDefault();
            $list
              .find('.m-menu__item')
              .first()
              .find('.m-menu__link')
              .focus();
            break;

          case 'End':
            event.preventDefault();

            $list
              .find('.m-menu__item')
              .last()
              .find('.m-menu__link')
              .focus();
            break;

          case 'Tab':
            const $_item     = $list.find('.m-menu__item');
            const $firstLink = $_item.first().find('.m-menu__link');
            const $lastLink  = $_item.last().find('.m-menu__link');

            if (
              ($(event.target).is($lastLink) && !event.shiftKey) ||
              ($(event.target).is($firstLink) && event.shiftKey)
            ) {
              event.preventDefault();
    
              if ($(event.target).is($lastLink)) {
                $firstLink.focus();
              } else {
                $lastLink.focus();
              }
            }
            break;
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Dropdown Open
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleDropdownOpen = $dropdown => {
        const buttonId    = $dropdown.data('controlledby');
        const $dropButton = $(`#${buttonId}`);

        $dropButton.addClass('m-menu__link--open');
        $dropdown.addClass('m-menu__dropdown--open');
        
        const $firstFocusable = $dropdown.find(this._focusable)[0];

        setTimeout(() => {
          if ($firstFocusable) $firstFocusable.focus();
        }, 100);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Dropdown Close
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleDropdownClose = $dropdown => {
        const buttonId    = $dropdown.data('controlledby');
        const $dropButton = $(`#${buttonId}`);

        $dropdown.removeClass('m-menu__dropdown--open');
        
        if ($dropButton[0]) {
          $dropButton
            .removeClass('m-menu__link--open')
            .focus();
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Dropdown Toggle
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleDropdownToggle = $dropdown => {
        $dropdown.slideToggle();

        if ($dropdown.hasClass('m-menu__dropdown--open')) {
          this.handleDropdownClose($dropdown);
        }
        else {
          this.handleDropdownOpen($dropdown);
        }
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.menu_links = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].menu_links = new MenuLinks(_[i], opt);
        else
          ret = _[i].menu_links[opt].apply(_[i].menu_links, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.m-menu').not('.m-menu .m-menu').menu_links();
});